import React, { useRef, useState } from 'react';
import { BsXLg } from 'react-icons/bs';
import Editable from '../editable';

export const Tag = ({
	name,
	isMine,
	setIsChanged,
	tags,
	setTags,
	index
}: {
	name: string;
	isMine: boolean;
	setIsChanged: (isChanged: boolean) => void;
	tags: string[];
	setTags: (tags: string[]) => void;
	index: number;
}) => {
	const refName = useRef<null>(null);
	const [tagName, setTagName] = useState(name);

	function removeTag() {
		const updatedTags = tags.slice();
		updatedTags.splice(index, 1);
		setTags(updatedTags);
		setIsChanged(true);
	}

	function updateTag(e: React.ChangeEvent<HTMLInputElement>) {
		setTagName(e.target.value.toUpperCase());
		setIsChanged(true);
		const copyTags = tags.slice();
		copyTags[index] = e.target.value.toUpperCase();
		setTags(copyTags);
	}

	return (
		<div
			className="flex relative justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 max-h-7 cursor-pointer group
												bg-gray-400 text-gray-200 border-green-200 
												hover:bg-purple-600 hover:border-purple-400 hover:text-gray-200 
												dark:hover:bg-purple-600 dark:hover:border-purple-400 dark:text-gray-300 dark:bg-gray-600"
		>
			{isMine ? (
				<>
					<Editable
						text={tagName.toUpperCase()}
						placeholder={'Insert tag name'.toUpperCase()}
						childRef={refName}
						type="input"
						className="text-xs font-bold mx-1"
						textColor="dark:text-gray-100 text-gray-700 hover:text-gray-100 transition-colors duration-500"
					>
						<input
							ref={refName}
							type="text"
							name="name"
							className="text-xs font-bold text-gray-700 hover:text-gray-100 dark:text-gray-100 px-1 pb-1.5
										bg-transparent transition-all duration-500 
										outline-none"
							placeholder=""
							value={tagName.toUpperCase()}
							onChange={(e) => updateTag(e)}
						/>
					</Editable>

					<button
						className="absolute bottom-4 -right-2 btn-error btn-xs btn btn-circle shadow-md
								scale-0 origin-left group-hover:scale-100
								opacity-0 group-hover:opacity-100 transition-all duration-500 text-center cursor-pointer"
						onClick={(e) => {
							e.stopPropagation();
							removeTag();
						}}
					>
						<BsXLg size={8} />
					</button>
				</>
			) : (
				<span className="text-xs font-bold mx-1">{tagName.toUpperCase()}</span>
			)}
		</div>
	);
};
